module.exports = "<div class=\"usc-store\">\r\n  <div class=\"row no-gutters usc_table_bar\">&nbsp;</div>\r\n  <br/>\r\n  <div [class]=\"loading_class\">Loading User Management...</div>\r\n  <iframe id=\"ifHome\" [src]=\"url\" width=\"100%\" style=\"border: 0px;\" (load)=\"onload($event)\" [class]=\"display_class\" scrolling=\"no\"></iframe>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-user-profile/usc-user-profile.component.html
// module id = ../../../../../src/app/components/usc-store/usc-user-profile/usc-user-profile.component.html
// module chunks = main